module.exports = __webpack_public_path__ + "src/assets/img/calc.7568395c.png";